//Chiamata da App.js per gestire il login dell'area admin
//utilizza un Box che contiene Navbar, i parametri per la chiamata al Auth0,
//il controllo dell'avvenuto login (Choices) e il Footer

import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import useStyleAdmin from "../../styles/adminStyles/useStyleAdmin";
import useStyleViewResearch from "../../styles/useStyleViewResearch";
import Choices from "./Choices ";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { Box } from "@material-ui/core";

const Admin = () => {
  const classes = useStyleAdmin();
  const classes2 = useStyleViewResearch();
  return (
    <>
      <Box className={classes2.wrapper}>
        <Navbar />
        <div className={classes.involucro}>
          <Auth0Provider
            domain="tuc.eu.auth0.com"
            clientId="zqzRqKbBAHois0sMmty7McHO3eAqNWG1"
            redirectUri={window.location.origin + process.env.PUBLIC_URL + "/Admin"}
          >
            <Choices />
          </Auth0Provider>
        </div>
        <Footer />
      </Box>
    </>
  );
};

export default Admin;
